import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, RequireRole, RoleHome } from "@/context/AuthContext";
import ClientsPage from "@/pages/ClientsPage";
import EditorPage from "@/pages/EditorPage";
import ReportPage from "@/pages/ReportPage";
import FnaReportPage from "@/pages/FnaReportPage";
import PresentPage from "@/pages/PresentPage";
import ProductsPage from "@/pages/ProductsPage";
import AdminDashboard from "@/pages/AdminDashboard";
import SubmissionPage from "@/pages/SubmissionPage";
import SettingsPage from "@/pages/SettingsPage";
import PortalPage from "@/pages/PortalPage";
import { AcceptInvitePage, ForgotPasswordPage, LoginPage, ResetPasswordPage } from "@/pages/AuthPages";

const admin = (el) => <RequireRole role="admin">{el}</RequireRole>;

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<RoleHome />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
          <Route path="/invite/:token" element={<AcceptInvitePage />} />
          <Route path="/portal" element={<RequireRole role="client"><PortalPage /></RequireRole>} />
          <Route path="/portal/report" element={<RequireRole role="client"><FnaReportPage clientView /></RequireRole>} />
          <Route path="/admin" element={admin(<AdminDashboard />)} />
          <Route path="/admin/settings" element={admin(<SettingsPage />)} />
          <Route path="/admin/submissions/:sid" element={admin(<SubmissionPage />)} />
          <Route path="/admin/submissions/:sid/report" element={admin(<FnaReportPage />)} />
          <Route path="/clients" element={admin(<ClientsPage />)} />
          <Route path="/clients/:id" element={admin(<EditorPage />)} />
          <Route path="/clients/:id/report" element={admin(<ReportPage />)} />
          <Route path="/clients/:id/fna" element={admin(<FnaReportPage />)} />
          <Route path="/clients/:id/present" element={admin(<PresentPage />)} />
          <Route path="/products" element={admin(<ProductsPage />)} />
          <Route path="*" element={<RoleHome />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
